var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.529,
    height: 24,
    viewBox: "0 0 22.529 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fa7268}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.011 0h4.968v4.968H5.011zM16.561 0h5.967v4.968h-5.967z",
    className: "a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.126 0h4.436v14.905h-4.436zM17.566 23.905s-9.847 1.508-14.017-7.452H0v-4.969h7.452s-.089 8.428 10.113 7.541Z",
    className: "a"
  })));
};
export default SvgLogo;